import { get, post, put } from './client';

export function getOrganizations() {
  return get('/organizations');
}

export function getOrganizationsForUser() {
  return get('/organizations/user');
}

export function getEnterprises() {
  return get('/enterprises');
}

export function getContractTypes() {
  return get('/contract-types');
}

export function getProducts() {
  return get('/products');
}

export function getOrganization(organizationId) {
  return get(`/organizations/${organizationId}`);
}

function appendIds(formData, key, items) {
  formData.append(key, (items || []).map((item) => item.id).join(','));
}

export function saveOrganization(organization) {
  const formData = new FormData();

  if (organization.logo) {
    formData.append('logo', organization.logo, organization.logo?.name);
  } else {
    formData.append('logo', organization.logo);
  }
  formData.append('name', organization.name);
  formData.append('isActive', organization.isActive);
  formData.append('enterprise', organization.enterprise?.id);
  formData.append('suretechAccountNumber', organization.suretechAccountNumber);
  appendIds(formData, 'contractTypes', organization.contractTypes);
  appendIds(formData, 'enabledProducts', organization.enabledProducts);

  return organization.id
    ? updateOrganization(organization, formData)
    : createOrganization(formData);
}

function createOrganization(formData) {
  return post('/organizations', formData);
}

async function updateOrganization(organization, formdata) {
  return put(`/organizations/${organization.id}`, formdata);
}
